import Style from "./LoginStyle";
import AuthContext from "../../contexts/authContext";
import Spinner from "../../shared/Spinner/Spinner";
import FloatingInput from "../../components/Inputs/InputFloat/FloatingInput";
import { useState, useContext, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function BoardsList(props) {
  const { LogIn, LogOut, IsLogged, ValidateLogin } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checkingLogin, setCheckingLogin] = useState(true);
  const [errorLogIn, setErrorLogIn] = useState(false);
  const logo = `${process.env.PUBLIC_URL + "/images/apemais-logo.svg"}`;

  useEffect(() => {
    console.log("Checando login");
    if (IsLogged()) {
      console.log("Tem token, verificando");
      setCheckingLogin(true);
      ValidateLogin().then(OnValidateLogin);
    } else setCheckingLogin(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function OnValidateLogin(valid: boolean) {
    setCheckingLogin(false);
    if (valid) props.history.push("/users");
    else {
      LogOut();
      console.error("Invalid Login");
    }
  }

  async function HandleLogin() {
    setCheckingLogin(true);
    let response = await LogIn(email, password);
    if (response == null) {
      setCheckingLogin(false);
      setErrorLogIn(true);
    } else {
      ///Como acabou de fazer o login, é valido
      OnValidateLogin(true);
    }
  }

  return (
    <Style>
      <HelmetProvider>
        <Helmet>
          <title>Login</title>
        </Helmet>
      </HelmetProvider>

      <form
        className="form boxShadow"
        onSubmit={(e) => {
          e.preventDefault();
          HandleLogin();
        }}
      >
        <img src={logo} width="200" alt="apemais"></img>
        <Spinner spinning={checkingLogin} />
        {errorLogIn && <p className="alert alert-error">Erro no login!</p>}
        <div className="container">
          <div>
            <FloatingInput
              type="text"
              name="email"
              autoComplete="email"
              disabled={checkingLogin}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
            />
          </div>
          <div>
            <FloatingInput
              type="password"
              name="password"
              autoComplete="current-password"
              disabled={checkingLogin}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Senha"
            />
          </div>

          <div className="container-buttons">
            <button
              className="button login"
              type="submit"
              disabled={checkingLogin}
            >
              LOGIN
            </button>
            <a className="register" href="https://beupse.com/">
              Não possui conta? entre em contato
            </a>
          </div>
        </div>
      </form>
    </Style>
  );
}
